import React from 'react';
import { useSellerInfoContext } from '../../../context/SellerInfoContext';
import { SellerProfessionTitle } from '../../SellerProfessionTitle';

export const SellerProfession: React.FC = () => {
  const { professionTitle } = useSellerInfoContext();
  if (!professionTitle) return null;
  return <SellerProfessionTitle>{professionTitle}</SellerProfessionTitle>;
};
